import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import { INotExportedOrderResult } from '../domains/entities/INotExportedOrderResult';
import { NotExportedOrderAdapter } from '../adapters/notExportedOrderAdapter';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';

/**
 *  「発注情報」を取ってきてUI表示ように加工するUseCase
 */
export class GetNotExportedOrderUseCase {
  private defaultPagingOptions: IPagingOptions = initPagingOptions(30);

  /**
   * 未出力の発注情報を取得する
   * @param repository - 取引情報の永続化の責務を負うクラス
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルター項目
   */
  public Execute = async (
    repository: OrderRepository,
    pagingOptions?: IPagingOptions,
    sortKey?: string,
    isAsc?: boolean,
    filterItems?: FilterContentItem[]
  ): Promise<INetworkResult<INotExportedOrderResult, Error>> => {
    try {
      const usePagingOptions = pagingOptions || this.defaultPagingOptions;
      const useFilterItem = filterItems ? FilterService.convertCustomerForecastFilterItems(filterItems) : undefined;
      // フィルターが未実装のためfilterItemは未使用
      const result = await repository.get(
        isAsc ? 'ASC' : 'DESC',
        usePagingOptions.pageSize,
        usePagingOptions.offset,
        true,
        sortKey,
        useFilterItem,
        undefined
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      const unorderedArrivalResult = NotExportedOrderAdapter.adapt(result.status.data);

      return {
        status: {
          type: 'success',
          data: unorderedArrivalResult,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
